<template>
	<b-container fluid class="p-0">
		<div v-for="(itemTS, index) in listTransportServices" :key="index">
			<h6 class="pt-2 pb-1 rounded text-dark  text-center u:bg-white-3 shadow-sm">

				<span class="badge badge-pill badge-success mr-2" v-if="itemTS.id==-1">Nuevo</span>
				{{"En servicio " +"#"+ itemTS.cartId.slice(5)}}

				<span v-if="hasQuantity(itemTS.tempAdditionalService.rates) && $hasPermission('reservation.specialRate') && propAddtServiceSelected.settingVars.editPrice" class="ml-2">
					<b-button @click="edit(itemTS.tempAdditionalService, true)" class="mr-1" variant="outline-success" size="sm" v-if="!itemTS.tempAdditionalService.quote.specialRate">
						<md-icon  icon="mode_edit " />
					</b-button>
					<b-button @click="edit(itemTS.tempAdditionalService, false)" class="mr-1" variant="outline-danger" size="sm" v-else>
						<md-icon  icon="clear " />
					</b-button>
				</span>
				<small class="pt-1 d-flex justify-content-center">{{itemTS.serviceTypeName}} ({{getDirection(itemTS)}})</small>
			</h6>

			<div class="row no-gutters justify-content-center">
				<div class="col-4 px-3" v-for="(itemPrice, indexPrice) in itemTS.tempAdditionalService.rates" :key="index+'_'+indexPrice">
					<h6 class="p-1 text-primary  text-center text-capitalize">{{itemPrice.category +" - "+'$'+itemPrice.price}}</h6>
					<div class="input-group mb-3 ">
						<div class="input-group-prepend">
							<button class="btn btn-outline-primary" :id="index+'_'+indexPrice" type="button" @click="decremetItem(index, indexPrice)">-</button>
						</div>
						<label class="form-control text-center">{{itemPrice.quantity}}</label>
						<div class="input-group-append ">
							<button class="btn btn-outline-primary" type="button" @click="incremetItem(index, indexPrice)">+</button>
						</div>
					</div>

				</div>

			</div>

			<b-container class="mb-0 pb-0" v-if="itemTS.tempAdditionalService.quote.specialRate">
				<b-row class="edit-amount py-2">
				<div class="col-12">
					<b-form-group
						id="input-group-1"
						label-for="input-1"
					>
						<label class="mr-sm-2">Nuevo Total</label>
							<b-input-group size="lg" prepend="$" :append="currency">
								<b-form-input v-model="itemTS.tempAdditionalService.quote.specialRateData.amount" type="number"></b-form-input>
							</b-input-group>
					</b-form-group>
				</div>
				<div class="col-12">
					<b-form-group id="input-group-2" label="Motivo" label-for="input-2">
						<b-form-textarea v-model="itemTS.tempAdditionalService.quote.specialRateData.reason" ></b-form-textarea>
					</b-form-group>
				</div>
				</b-row>
			</b-container>
		</div>

		<div class="w-100 d-flex justify-content-center align-items-center p-3 shadow-lg bg-white rounded">
			<h4 class="flex-grow-1 p-1 m-0 text-success text-uppercase">{{currency}}$ {{_newCartTotal}} </h4>
			<button @click="sendConfirmation()" class="align-self-end btn btn-success">Confirmar</button>
		</div>
		<b-overlay :show="showConfirmation" no-wrap>
			<template #overlay>
				<div ref="dialog" tabindex="-1" role="dialog" class="text-center p-1">
                <strong>¿Esta seguro que desea aplicar el precio especial?</strong><br>

                 <p>Precio original: {{originalPriceFormatted}} </p>
                 <p>Precio especial: {{newPriceFormatted}} </p>
                 <h4 class="text-success"><b>{{difference}}</b></h4>
					<div class="text-center">
						<b-button variant="outline-danger" class="mr-3" @click="()=>{showConfirmation=false}">
							Cancelar
						</b-button>
						<b-button variant="outline-success" @click="sendConfirmation()">Confirmar</b-button>
					</div>
				</div>
			</template>
		</b-overlay>
	</b-container>
</template>

<script>
export default {
	props:{
		propViewModel:Object,//lista de rides
		propAddtServiceSelected:Object,//item del servicio adicional seleccionado
		currency:{type: String, required: true,default: "usd"}
	},
	data(){
		return{
			listTransportServices: null,
			showConfirmation: false,
		}
	},
	computed:{
		_cartTotal() {
			let total=0;
			//validamos que exista una lista de transport services
			if(this.listTransportServices==null){
				return total;
			}
			//iteramos para obtener el total de suma del paquete aplicado a todos los rides
			this.listTransportServices.forEach(itemTS => {
				//verificamos que exista la key de rates
				if(('rates' in itemTS.tempAdditionalService)){
					//iteramos en los rates para obtener el total del paquete
					itemTS.tempAdditionalService.rates.forEach(itemPrice => {
						total=total+(itemPrice.price*itemPrice.quantity)
					});
				}
			});
			return total;
		},
		_newCartTotal() {
			return this.listTransportServices?.reduce((acc, curr) => (
				acc += curr.tempAdditionalService?.quote.bookingPriceTotal || 0
			), 0) || 0
		},
		originalPriceFormatted(){
            return "$"+this._cartTotal+" "+ this.propAddtServiceSelected.priceCurrency;
        },
        newPriceFormatted(){
            return "$"+this._newCartTotal+" "+ this.propAddtServiceSelected.priceCurrency;
        },
		difference(){
            let res = parseFloat(this._newCartTotal-this._cartTotal).toFixed(2)
            if(res>=0){
                return "Total AGREGADO: $"+res+" "+this.propAddtServiceSelected.priceCurrency
            }else{
                return "Total DESCUENTO: $"+Math.abs(res)+" "+this.propAddtServiceSelected.priceCurrency
            }
        }
	},
	mounted(){
		//hacemos uns espera con nexttick, para recuperar los props y refrescar los datos
		// this.$nextTick(()=>{
		setTimeout(()=>{
			//recuperamos los transport services nuevos y con estado activo y pendiente
			this.listTransportServices = JSON.parse(JSON.stringify(this.propViewModel.transportServices));
			this.listTransportServices = this.listTransportServices.filter((item)=>{
				return item.id==-1 || item.status == "active" || item.status == "pending";//??TS || item.status == "active"
			});
			//filtramos todos los rides seleccionados
			this.listTransportServices.forEach(itemTS => {
				//agregamos a cada ride una propiedad auxiliar para guardar los servicios adicionales
				//ya confirmados y otro llamado(tempAdditionalService) que solo servivara para confirmar la cantidad de un servicio seleccionado
				//verificamos que no existan los parametros
				// if(("tempAdditionalService" in itemTS)==false){
					//buscamos si existe un servicio adicional relacionado con el transport service
					let modelServiceAdditional={};
					//filtramos del viewModel solo los servicios adicional nuevos
					let auxAdditionalServices = this.propViewModel.additionalServices.filter(item=>item.id == -1);
					let existAddtService = auxAdditionalServices.find(itemAddtService=>{
						// if("tempAdditionalService" in itemTS){
							// coinciden los id de referencias?
							if(itemTS.cartId==itemAddtService.related.transportServiceReference){
								if(itemAddtService.id==-1){
									if(this.propAddtServiceSelected.id == itemAddtService.additionalServiceTypeId){
										modelServiceAdditional=itemAddtService;
										return true;
									}
								}
							}
						// }
						return false;
					});
					if(existAddtService){
						//verificamos y recuperamos las catgorias que no existan dentro de los precios(rates) de los adicionalServices
						let tempRate=[];//variable para recuperar los rates ordenados
						this.propAddtServiceSelected.prices.forEach((element) => {
							//verificamos si existe algun precio con la misma categoria de los rides
							let existRate = modelServiceAdditional.rates.find(newAS=>newAS.category == element.category);
							if(existRate){
								tempRate.push(existRate);
							}else{
								tempRate.push(element);
							}
						});
						//asignamos el array de rates recuperados
						modelServiceAdditional.rates=tempRate;

						//modificamos el temp service additional
						Object.assign(itemTS, {tempAdditionalService: modelServiceAdditional});
					}else{
						//armamos el modelo nuevo para el servicio adiconal
						modelServiceAdditional=  {
							id: -1,
							related: {
								transportServiceReference: itemTS.cartId,
								type: "cart"
							},
							name:this.propAddtServiceSelected.name,
							additionalServiceTypeId: this.propAddtServiceSelected.id,
							bookingPriceSubtotal: 0,//?
							bookingCurrency: this.propAddtServiceSelected.priceCurrency,
							total: 0,//?total del servicio
							quote: {
								bookingPriceTotal: 0,
								bookingPriceTotalOriginal: 0,
								specialRate: false,
								bookingCurrency: this.propAddtServiceSelected.priceCurrency,
								specialRateData: null
							},
							currency: this.propAddtServiceSelected.priceCurrency,
							rates:this.propAddtServiceSelected.prices,//{category: "unit",quantity: 0,price: 0}
							status: "pending",
							fromQuote: true,//? bandera para indicar que se agrego desde desde el cotizador
						};
						Object.assign(itemTS, {tempAdditionalService: modelServiceAdditional});
					}
				// }
			});
		// });
		}, 200);
	},
	methods:{
		hasQuantity(rates) {
			return !!rates.find(({quantity}) => quantity > 0)
		},
		getDirection(itemTS) {
			if(itemTS.pickup && itemTS.dropoff) {
				if(itemTS.pickup.isAirport) return 'A2H'
				if(itemTS.dropoff.isAirport) return 'H2A'
				return 'P2P'
			}
			return 'Desconocido'
		},
		edit({quote}, isEdit) {
			if(isEdit) {
				quote.specialRate = true
				quote.specialRateData = {
					amount: quote.bookingPriceTotal,
					reason: ''
				}
			} else {
				quote.specialRate = false
				quote.specialRateData = null
			}
		},
		calculaTotalAddtService(){
			//validamos que exista una lista de transport services
			if(this.listTransportServices==null){
				return;
			}
			//iteramos para obtener el total de suma del paquete aplicado a todos los rides
			this.listTransportServices.forEach(itemTS => {
				//verificamos que exista la key de rates
				if(('rates' in itemTS.tempAdditionalService)){
					let total=0;
					//iteramos en los rates para obtener el total del paquete
					itemTS.tempAdditionalService.rates.forEach(itemPrice => {
						total += itemPrice.price*itemPrice.quantity
					});
					itemTS.tempAdditionalService.quote.bookingPriceTotal=total;

				}
			});
		},
		sendConfirmation(){
			//validamos los campos de cantidad por AdtService
			if (this._cartTotal<=0) {
				this.$root.showAlert("Debe seleccionar al menos un precio", { variant: "danger" });
				return;
			}

			let hasInvalid = false
			let hasSpecialPrice = false
			this.listTransportServices.forEach(({tempAdditionalService}) => {
				const { quote } = tempAdditionalService
				if (quote.specialRate) {
					hasSpecialPrice = true
					if (!quote.specialRateData || quote.specialRateData.amount <=0 || !quote.specialRateData.amount) {
						hasInvalid = true
						return this.$root.showAlert("Debe agregar un precio valido", { variant: "danger" });
					}
					if (!quote.specialRateData.reason) {
						hasInvalid = true
						return this.$root.showAlert("El motivo es requerido", { variant: "danger" });
					}
					tempAdditionalService.quote.bookingPriceTotalOriginal = tempAdditionalService.rates.reduce((acc, curr) => (acc+= (curr.price * curr.quantity)), 0)
					tempAdditionalService.quote.bookingPriceTotal = Number(tempAdditionalService.quote.specialRateData.amount)

				}
			})


			if(hasInvalid) return;
			if(hasSpecialPrice) {
				if(!this.showConfirmation) {
					return this.showConfirmation = true
				} else {
					this.showConfirmation = false
				}
			}


			//recuperamos los tempAdditionalServices y los vinculamos a additionalServices del modelo principal
			let auxViewModel = JSON.parse(JSON.stringify(this.propViewModel));
			// let auxAdditionalServices = [];
			this.listTransportServices.forEach((itemTS)=>{

				let indexAddtionalService=-1;//indice que guarda la posicion del servicio adicional editado
				let itemAddtionalService={};//item de la posicion del servicio adicional editado
				//buscamos en el modelo original si existe un servicio adicional relacionado con el transport service
				//mas antes filtrando solo los servicios adicionales nuevos
				let auxAdditionalServices = auxViewModel.additionalServices;
				let existAddtService = auxAdditionalServices.find((itemAS, indexAS)=>{
					// coinciden los id de referencias?
					if("related" in itemAS){
						if(itemTS.cartId==itemAS.related.transportServiceReference){
							if(this.propAddtServiceSelected.id == itemAS.additionalServiceTypeId){
								indexAddtionalService = indexAS;
								itemAddtionalService = itemTS.tempAdditionalService;
								// indexAddtionalService=JSON.parse(JSON.stringify(itemTS.tempAdditionalService));
								return true;
							}
						}
					}
					return false;
				});
				if(existAddtService){
					auxViewModel.additionalServices[indexAddtionalService]=itemAddtionalService;
				}else{
					auxViewModel.additionalServices.push(itemTS.tempAdditionalService);
				}

			});

			auxViewModel.additionalServices = auxViewModel.additionalServices.filter((itemAS)=>{
				if("rates" in itemAS){
					let arrRates = itemAS.rates.filter(itemRate=>itemRate.quantity > 0);
					if(arrRates.length > 0){
						itemAS.rates = arrRates;
						return true;
					}else{
						return false;
					}
				}else{
					return true;
				}


			});

			this.$emit('confirmQuantity', auxViewModel, "TransportServices")
		},
		incremetItem(indexSeletedTS, indexSelectedPrice){

			let auxListTransportServices=JSON.parse(JSON.stringify(this.listTransportServices))
			if(auxListTransportServices[indexSeletedTS].tempAdditionalService.rates[indexSelectedPrice].quantity>=100){
				auxListTransportServices[indexSeletedTS].tempAdditionalService.rates[indexSelectedPrice].quantity=100;
			}else{
				auxListTransportServices[indexSeletedTS].tempAdditionalService.rates[indexSelectedPrice].quantity++;
			}
			this.listTransportServices=auxListTransportServices;
			this.calculaTotalAddtService();
		},
		decremetItem(indexSeletedTS, indexSelectedPrice){
			//creamos un axuliar clon de listTransportServices
			let auxListTransportServices=JSON.parse(JSON.stringify(this.listTransportServices))
			//con los indices verificamos e incrementamos el valor de quantity
			if(auxListTransportServices[indexSeletedTS].tempAdditionalService.rates[indexSelectedPrice].quantity<=0){
				auxListTransportServices[indexSeletedTS].tempAdditionalService.rates[indexSelectedPrice].quantity=0;
			}else{
				auxListTransportServices[indexSeletedTS].tempAdditionalService.rates[indexSelectedPrice].quantity--;
			}
			//reemplazamos el actual listTransportServices con el auxiliar creado
			this.listTransportServices=auxListTransportServices;
			this.calculaTotalAddtService();
		}
	},
}
</script>

<style lang="scss" scoped>
.edit-amount {
	background-color: #f2f2f2;
}
</style>
